<script setup lang="ts">
import { posthog } from 'posthog-js'
import { computed, watch } from 'vue'
import { RouterView, useRoute, useRouter } from 'vue-router'

import ErrorComponent from '@/components/error/ErrorComponent.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import FullscreenLayout from '@/layouts/FullscreenLayout.vue'
import { config } from '@/lib/helpers'
import { useErrorStore } from '@/stores/error.stores'
import { useUserStore } from '@/stores/user.stores'

const currentRoute = useRoute()
const errorStore = useErrorStore()
const router = useRouter()
const userStore = useUserStore()

const layouts = {
  default: DefaultLayout,
  fullscreen: FullscreenLayout,
}
const layoutComponent = computed(() => layouts[currentRoute.meta.layout as keyof typeof layouts] ?? DefaultLayout)
const handleRetry = () => {
  errorStore.clearError()
  router.go(0)
}

const clearErrorOnRouteChange = () => {
  if (errorStore.currentError) {
    errorStore.clearError()
  }
}

const isGlobalError = computed(() => errorStore.currentError?.isGlobal)

watch(
  () => currentRoute.path,
  () => {
    clearErrorOnRouteChange()
  },
)

watch(
  userStore,
  (store) => {
    if (config.isPosthogEnabled) {
      if (!store.isLoading && store.isInitialized) {
        const isAdmin = store.isAdmin
        if (!isAdmin) {
          posthog.opt_in_capturing()
        }
      }
    }
  },
  { immediate: true },
)
</script>
<template>
  <div>
    <component :is="layoutComponent">
      <RouterView v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <component :is="Component" v-if="!isGlobalError" :key="route.name" />
          <ErrorComponent v-else :handle-retry="handleRetry" />
        </transition>
      </RouterView>
    </component>
  </div>
</template>
